<div class="share-box">
  <div class="title">SHARE, SHOW THAT YOU CARE</div>
  <div class="subtitle">Every share can potentially get 4x more contributions</div>
  <div class="d-flex box-wr justify-content-center">
    <div class="d-flex align-content-center">
      <div class="fb-share-component">
        <app-fb-share [label]="'Share'" class="fb-share-component"></app-fb-share>
      </div>
      <div class="whatsapp-share-component">
        <app-whatsapp-share [label]="'Share'"></app-whatsapp-share>
      </div>
    </div>
  </div>
</div>